(function () {
    'use strict';

    // @ngInject
    Services.plaid = function plaid($window, ThirdPartyLoaderService) {
        return ThirdPartyLoaderService.loadUrlPromise('https://cdn.plaid.com/link/v2/stable/link-initialize.js', function() {return $window.Plaid;});
    };

}());
